<ng-container *transloco="let t">
  <div class="widget-header">
    <div class="truncate-text title-wrapper expansion-panel__title-wrapper">
      <span class="expansion-panel__title">{{ title }}</span>

      <div class="expansion-panel__close">
        <xi-icon-button icon="cancel" [hasAnimation]="true" (onClick)="close()"></xi-icon-button>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</ng-container>
